import { mapGetters } from "vuex";

export const connectedToInternet = { ...mapGetters(["connectedToInternet"]) };
export const getUserID = { ...mapGetters(["userID"]) };
export const authComputed = { ...mapGetters(["loggedIn"]) };
export const getZones = { ...mapGetters(["zones"]) };
